export enum UiState {
	WAITING_INPUT = "WAITING_INPUT",
	LOADING_EFFECTS = "LOADING_EFFECTS",
	PROCESSING_PRE_EFFECTS = "PROCESSING_PRE_EFFECTS",
	DRAWING_BOARD = "DRAWING_BOARD",
	PROCESSING_POS_EFFECTS = "PROCESSING_POS_EFFECTS",
}
